import bluebird from 'bluebird'

import {
  CreateReducer,
  CreateAction,
} from '@kaidam/fc-shared/src/frontend/store/utils/store'

import {
  NetworkThunk,
} from '@kaidam/fc-shared/src/frontend/store/utils/network'

import {
  setHTTPToken,
  unsetHTTPToken,
  getHTTPTokenHeaders,
  handlers,
} from '@kaidam/fc-shared/src/frontend/store/utils/api'

import {
  REFRESH_TOKEN_DELAY,
} from '../../settings'

import {
  AuthState,
  ReducerHandler,
  ThunkHandler,
} from '../../types/store'

const prefix = 'auth'

/*

  initial state

*/
const initialState: AuthState = {
  loaded: false,
  token: '',
  loggedIn: false,
}

/*

  utils

*/
let refreshTokenLoop: any = null

/*

  reducers

*/
const setToken: ReducerHandler<AuthState, string> = (state, action) => {
  const token = action.payload
  if(token) {
    setHTTPToken(token)
  }
  else {
    unsetHTTPToken()
  }
  localStorage.setItem('token', token)
  state.token = token
}

/*

  thunks

*/
const authenticate: ThunkHandler<string, void> = (token) => async (dispatch, getState) => {
  // TODO: work out what to do here
}

const refreshToken: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  try {
    // const { token } = await handlers.post<void, IData_UserToken>('/auth/token')
    // dispatch(actions.setToken(token))

    // TODO: work out what to do here
  } catch(e) {
    // dispatch(actions.setToken(''))
    // dispatch(snackbarActions.setError(`you have been logged out`))
    // dispatch(logout())
  }
}

const startTokenLoop: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  if(refreshTokenLoop) {
    clearInterval(refreshTokenLoop)
  }
  refreshTokenLoop = setInterval(() => {
    dispatch(refreshToken())
  }, REFRESH_TOKEN_DELAY)
}

const stopTokenLoop: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  if(refreshTokenLoop) {
    clearInterval(refreshTokenLoop)
    refreshTokenLoop = null
  }
}

/*

  collections

*/
const reducers = {
  setToken,
}

export const actions = {
  setToken: CreateAction(prefix ,'setToken', setToken),
  authenticate,
  refreshToken,
  startTokenLoop,
  stopTokenLoop,
}

export const reducer = CreateReducer<AuthState>({
  prefix,
  initialState,
  reducers,
})

export default actions